import React from "react";

import BearHand from "../Images/Bear_highfive.png";
import SkyBackground from "../Images/sky.gif";

export default function Philosophy() {
    return <div className="Section sTwo">
                <div className="sTwoBackground">
                <img loading="lazy" decoding="async" fetchPriority="low" className="sTwoSky" src={SkyBackground} alt="" aria-hidden="true" />
                <img loading="lazy" decoding="async" className="bear-hand" src={BearHand} alt="Goldloxe bear hand" />
                <div className="sectionText">
                    <h3>We’re living on a rock hurtling through space at 67,000mph, locked at the perfect distance from the sun. Scientists call it The Goldlicks Zone. </h3>
                </div>
                <div className="sectionText">
                    <h3> Not too hot. Not too cold. Just Right! Don’t waste the trip </h3>
                </div>
                </div>
            </div>
}